module.exports = "<div class=\"page-routing\" style=\"width: 100%;height: 2px;position: fixed !important;z-index: 999999 !important;top:0\" *ngIf=\"isRouting\"></div>\r\n<router-outlet></router-outlet>\r\n<simple-notifications [options]=\"\r\n{\r\nposition: ['bottom', 'right'],\r\nlastOnBottom: true,\r\nshowProgressBar: true,\r\npauseOnHover: true,\r\nclickToClose: true,\r\nmaxLength: 100,\r\nmaxStack:8,\r\nanimate: 'fromRight',\r\ntimeOut: 3000\r\n}\">\r\n</simple-notifications>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main